console.log('hello from custom js');

document.addEventListener('DOMContentLoaded', function () {
  const modeToggle = document.getElementById('modeToggle');
  const sunIcon = document.getElementById('sunIcon');
  const moonIcon = document.getElementById('moonIcon');
  const darkModeClass = 'dark-mode';

  // Check localStorage for dark mode preference
  if (localStorage.getItem('theme') === 'dark') {
    document.body.classList.add(darkModeClass);
    sunIcon.style.display = 'inline'; // Show sun icon in dark mode
    moonIcon.style.display = 'none';  // Hide moon icon in dark mode
  }

  // Toggle dark mode on button click
  modeToggle.addEventListener('click', () => {
    document.body.classList.toggle(darkModeClass);

    // Toggle icons and save preference
    if (document.body.classList.contains(darkModeClass)) {
      sunIcon.style.display = 'inline';
      moonIcon.style.display = 'none';
      localStorage.setItem('theme', 'dark');
    } else {
      sunIcon.style.display = 'none';
      moonIcon.style.display = 'inline';
      localStorage.setItem('theme', 'light');
    }

    // Update images for the new theme
    const isDarkMode = localStorage.getItem('theme') === 'dark';
    updateImagesForTheme(isDarkMode);
  });

  // Function to update images based on mode
  function updateImagesForTheme(isDarkMode) {
    document.querySelectorAll('img.theme-image').forEach((img) => {
      let currentSrc = img.getAttribute('src');
      
      // Replace 'light' with 'dark' or vice versa
      if (isDarkMode) {
        img.src = currentSrc.replace('-light', '-dark');
      } else {
        img.src = currentSrc.replace('-dark', '-light');
      }
    });
  }

  // Initial setup based on saved preference
  const isDarkMode = localStorage.getItem('theme') === 'dark';
  updateImagesForTheme(isDarkMode);

  
});
